import ProductList from './ProductList';
import { useEventContext } from 'context/EventContext';
import { useCheckoutContext } from 'context/CheckoutContext';

export default function Tickets() {
    const { event } = useEventContext();
    const {
        products,
        bundles,
        handleAddBundle,
        handleAddProduct,
        handleRemoveBundle,
        handleRemoveProduct,
    } = useCheckoutContext();

    return (
        <ProductList
            parentMode={event.parentMode}
            products={products}
            bundles={bundles}
            groups={event.groups}
            chargesEnabled={event.chargesEnabled}
            currency={event.currency || 'CAD'}
            onAddProduct={handleAddProduct}
            onRemoveProduct={handleRemoveProduct}
            onAddBundle={handleAddBundle}
            onRemoveBundle={handleRemoveBundle}
        />
    );
}
